import React from "react";
import { Box, Button, Heading, Text, SimpleGrid, VStack, HStack, Icon, List, ListItem, ListIcon, Container } from "@chakra-ui/react";
import { Check, X } from "lucide-react";
import { plans, features } from "@hz/stealthy-gmc-cloaker-common/plans"
import { PlanNamesType } from "@hz/stealthy-gmc-cloaker-common/constants";

interface PlanSelectionProps {
  onSelectPlan: (plan: PlanNamesType) => void;
  onClose: () => void;
  showSteps?: boolean;
}

export const PlanSelection = ({ onSelectPlan, onClose, showSteps = true}: PlanSelectionProps) => {
  return (
    <Box bg="gray.900" minH="100vh" p={8} width="100%">
     {/* <Button
        position="fixed"
        top={4}
        right={4}
        variant="ghost"
        color="gray.400"
        onClick={onClose}
        _hover={{
          bg: 'gray.800',
          color: 'white',
        }}
        size="lg"
        px={6}
        // borderRadius="full"
        borderWidth={1}
        borderColor="gray.700"
      >
        Cancel
      </Button> */}
      <Container maxW="container.4xl">
        <VStack spacing={6} mb={12} textAlign="center">
          <Heading size="xl" color="white">
            💼 Choose Your Plan
          </Heading>
          <Text color="gray.300" maxW="800px">
            All plans include full StealthyGMC protection, expert setup by our
            team, and stealth rules tailored to your store.
          </Text>
        </VStack>
        <SimpleGrid
          columns={{
            base: 1,
            lg: plans.length
          }}
          spacing={8}
          mb={12}
        >
          {plans.map((plan) => (
            <Box
              key={plan.name}
              bg="#1A1A22"
              border="1px solid"
              borderColor="#4285f4"
              borderRadius="lg"
              p={6}
              position="relative"
              transition="all 0.3s"
              _hover={{
                transform: 'translateY(-4px)',
                boxShadow: '0 12px 24px -10px rgba(0, 0, 0, 0.3)',
                borderColor: '#4285f4',
              }}
            >
              <VStack align="stretch" spacing={5}>
                <Heading size="md" color="white">
                  {plan.emoji} {plan.name}
                </Heading>
                <Box>
                  <Text fontSize="3xl" fontWeight="bold" color="white">
                    ${plan.price}
                    <Text as="span" fontSize="sm" color="gray.400">
                      /mo
                    </Text>
                  </Text>
                  <Text fontSize="sm" color="gray.400">
                    {plan.sessions} monthly sessions*
                  </Text>
                </Box>
                <List spacing={3}>
                  {features.map((feature, index) => (
                    <ListItem
                      key={index}
                      display="flex"
                      alignItems="flex-start"
                    >
                      <ListIcon as={Check} color="#3182ce" mt={1} />
                      <Text fontSize="sm" color="gray.300">
                        {feature}
                      </Text>
                    </ListItem>
                  ))}
                </List>
                <Text fontSize="sm" color="gray.400">
                  💰 ${plan.setupFee} one-time setup fee
                </Text>
                <Button
                  size="lg"
                  width="100%"
                  bg="#4285f4"
                  color="white"
                  onClick={() => onSelectPlan(plan.name)}
               
                >
                  {`Choose ${plan.name}`}
                </Button>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>

        <Text
          fontSize="xs"
          color="gray.500"
          textAlign="center"
          maxW="800px"
          mx="auto"
          mb={10}
        >
          *A billable session is every visitor interaction with your website that
          begins when a user first loads a page containing our code and
          continues until the browser tab is closed. Unused sessions do not
          carry forward.
        </Text>

        {/* <Box
          bg="#1A1A22"
          border="1px solid #2A2A32"
          borderRadius="lg"
          p={8}
          mb={8}
          textAlign="center"
        >
          <Heading size="md" mb={4} color="white">
            👑 Need more than 600,000 sessions per month?
          </Heading>
          <Text color="gray.300" mb={6}>
            Contact us for custom enterprise plans.
          </Text>
          <Button
          
            size="lg"
            bg="transparent"
            color="white"
             border="1px solid #4285f4"

          >
            Request Access
          </Button>
        </Box> */}
       
      </Container>

      
 
    </Box>
  );
};
